import type { z as Z } from 'zod';

import { z } from 'zod';

import { KEBAB, narratorFields, nodeFields } from './storyData.js';

/** The activity types a lesson's test step may use to check knowledge. */
export const KNOWLEDGE_CHECK_ACTIVITY_TYPES = new Set<string>([
  'swipe_select',
  'drag_ordering',
  'drag_pairing',
  'phrase_matching',
  'multi_choice_single_response',
  'multi_choice_multi_response',
]);

export const LessonNode = z.looseObject({
  ...nodeFields,
  nodeType: nodeFields.nodeType.optional(),
});

/** The inner `storyData` of a lesson: narrator-led, no characters. */
export const Lesson = z.looseObject({
  id: z.string().regex(KEBAB),
  title: z.string().min(1),
  startNodeId: z.string(),
  defaultBackgroundImageUrl: z.string().min(1).optional(),
  ...narratorFields,
  characters: z.array(z.unknown()).max(0).optional(),
  nodes: z.array(LessonNode).min(1),
});

export type Lesson = Z.infer<typeof Lesson>;
